import React from 'react';

export const LodgingIcon = () => (
  <svg
    height="15px"
    id="lodging-15"
    version="1.1"
    viewBox="0 0 15 15"
    width="15px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5,2.5C0.2,2.5,0,2.7,0,3v7.5v2C0,12.8,0.2,13,0.5,13S1,12.8,1,12.5V11h13v1.5&#xA;&#x9;c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-2c0-0.3-0.2-0.5-0.5-0.5H1V3C1,2.7,0.8,2.5,0.5,2.5z M3.5,3C2.7,3,2,3.7,2,4.5l0,0&#xA;&#x9;C2,5.3,2.7,6,3.5,6l0,0C4.3,6,5,5.3,5,4.5l0,0C5,3.7,4.3,3,3.5,3L3.5,3z M7,4C5.5,4,5.5,5.5,5.5,5.5V7h-3C2.2,7,2,7.2,2,7.5v1&#xA;&#x9;C2,8.8,2.2,9,2.5,9H6h9V6.5C15,4,12.5,4,12.5,4H7z"
      id="rect6507"
    />
  </svg>
);
